import PropTypes from 'prop-types';
import React from 'react';

export function TableColgroup({ cols }) {
  const columns = cols.map(header => <col key={header.key} width={header.colWidth} />);

  return <colgroup>{columns}</colgroup>;
}

TableColgroup.propTypes = {
  cols: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      colWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
};
